import { FC, memo, useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import RidGenerator from 'utils/swarm/rid-generator';
import { AToZData } from 'interfaces/generic';
import { getBetHistoryCount } from 'services/account-settings';
import { executeCommand } from 'services/get-data-level';
import { setOpenBetsCount } from 'store/actions/betslip';
import {
  getAllLsBets,
  getBettedTrigger,
  getOpenBetsCount,
  getUpdateOpenBetsTrigger
} from 'store/selectors/betslip';
import { getFavoriteCasinoGames } from 'store/selectors/fav-data';
import { getIsLoggedIn } from 'store/selectors/user-data';
import './index.less';

type Props = {
  tab: AToZData;
  setShowOpenBets: Function;
};

export const NavigationItemBadge: FC<Props> = memo(
  ({ tab, setShowOpenBets }) => {
    const allLsBets = useSelector(getAllLsBets);
    const isLoggedIn = useSelector(getIsLoggedIn);
    const updateOpenBetsTrigger = useSelector(getUpdateOpenBetsTrigger);
    const doBetDone = useSelector(getBettedTrigger);
    const favorites = useSelector(getFavoriteCasinoGames);
    const openBetsCount = useSelector(getOpenBetsCount);
    const isInitialMount = useRef(true);
    const [liveGamesCount, setLiveGamesCount] = useState(0);

    const showOpenBets = useMemo(() => {
      return (
        tab.type === 'betslip' &&
        !allLsBets?.length &&
        isLoggedIn &&
        !!openBetsCount
      );
    }, [isLoggedIn, allLsBets?.length, openBetsCount, tab.type]);

    useEffect(() => {
      setShowOpenBets(showOpenBets);
    }, [showOpenBets]);

    useEffect(() => {
      if (tab.type === 'betslip' && isLoggedIn && openBetsCount === null) {
        getBetHistoryCount((count: number) => {
          setOpenBetsCount(count);
        });
        isInitialMount.current = false;
      }
    }, [isLoggedIn, doBetDone, updateOpenBetsTrigger, tab.type]);

    useEffect(() => {
      if (tab.type === 'live') {
        executeCommand(
          RidGenerator.gForSubscribe(),
          { game: '@count' },
          { game: { type: 1 } },
          (data: { game: number }) => {
            setLiveGamesCount(data?.game);
          },
          true,
          (data: { game: number }) => {
            setLiveGamesCount(data?.game);
          }
        );
      }
    }, [tab.type]);

    return (
      <div className="bet-count__wrapper">
        {tab.type === 'betslip'
          ? showOpenBets
            ? openBetsCount || 0
            : allLsBets?.length
          : (tab.type === 'favorite' ? favorites?.length || '0' : 0) ||
            liveGamesCount}
      </div>
    );
  }
);
